

import { HttpInterceptorFn } from '@angular/common/http';
export const tokenInterceptor: HttpInterceptorFn = (req, next) => {

  var headertoken = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
  var cloneReq;
  
  if(headertoken.token){
    cloneReq = req.clone({
      setHeaders: {
        'x-auth-token':headertoken.token
      }
    });
  }else{
    cloneReq=req.clone();
  }
  
    return next(cloneReq);

};